const isGenAIPRSKillswitchEnabled = () => Sephora.configurationSettings?.genAIPRS?.isEnabled;

const isGenAIPRSEnabledSelector = () => isGenAIPRSKillswitchEnabled();

export {
    isGenAIPRSEnabledSelector, isGenAIPRSKillswitchEnabled
};
